import { action } from '@ember/object';
import Component from '@glimmer/component';

import { SeriesVisualization } from 'webapp/enums/enums';

// this can be included block-wide (no dataSelect) or per data-select
import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';
import type VisualizationHorizontalBarChart from 'webapp/models-custom/visualization/horizontal-bar-chart';

interface Args {
	blockM: Block;
	dataSelect?: DataSelect;
}

export default class BlockSettingsMetricStackedComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get itemsToStack(): string {
		const visualization = this.blockSetup.visualization;
		if (visualization.isFunnel || visualization.isPipeline) {
			return 'dimension values';
		} else if (visualization.isHorizontalBarChart) {
			return 'bars';
		} else if (this.isForSingleDataSelect) {
			const dsVisualization = this.args.dataSelect?.visualization;
			if (dsVisualization) {
				return dsVisualization === SeriesVisualization.LINE ? 'lines' : 'bars';
			} else {
				return visualization.isLineChart ? 'lines' : 'bars';
			}
		} else {
			return 'series'; // this should not appear
		}
	}

	get isForSingleDataSelect(): boolean {
		return !!this.args.dataSelect;
	}

	get selected(): boolean {
		return this.isForSingleDataSelect
			? !!this.args.dataSelect?.isStacked
			: (this.blockSetup.visualization as VisualizationHorizontalBarChart).isStacked;
	}

	@action
	changeSelected(isStacked: boolean): void {
		const dataSelectsToUpdate = this.args.dataSelect
			? [this.args.dataSelect]
			: this.blockSetup.dataSelectsShown;

		dataSelectsToUpdate.forEach((ds) => {
			this.blockSetup.changeIsStacked(ds, isStacked);
			this.blockSetup.trackBlockPropertyMetricSettingsChangeEvent(ds, { stack: isStacked });
		});
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="isStacked"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Stack {{this.itemsToStack}}</label>
		</div>
	</template>
}
